var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreReferarals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    "data-bbox": "20 20 160 160",
    viewBox: "20 20 160 160",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "shape",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.001 20C55.818 20 20 55.817 20 100s35.818 80 80.001 80C144.182 180 180 144.183 180 100s-35.818-80-79.999-80zm39.726 85.834l-7.253 7.254-32.472 32.472-32.472-32.472-7.256-7.254c-8.93-8.93-8.93-23.542 0-32.472s23.541-8.93 32.472 0l7.256 7.254 7.253-7.254c8.93-8.93 23.541-8.93 32.472 0s8.93 23.543 0 32.472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreReferarals);
export default __webpack_public_path__ + "static/media/more_referarals.14a6643633431882666c6804b83cd7a8.svg";
export { ForwardRef as ReactComponent };